import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'lp2-recovery-page',
  templateUrl: './recovery-page.component.html',
  styleUrls: ['./recovery-page.component.scss']
})
export class RecoveryPageComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./ts/app/login/recovery-page/recovery-page.component.ts